import { render, staticRenderFns } from "./TagSelectV2.vue?vue&type=template&id=2c4a5f6e"
import script from "./TagSelectV2.vue?vue&type=script&lang=js"
export * from "./TagSelectV2.vue?vue&type=script&lang=js"
import style1 from "./TagSelectV2.vue?vue&type=style&index=1&id=2c4a5f6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports